var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16H32V26H28V16ZM28 28H32V32H28V28ZM44 24C44 27.713 42.525 31.274 39.8995 33.8995C37.274 36.525 33.713 38 30 38C25.24 38 21 35.62 18.5 32H4C1.78 32 0 30.2 0 28V4C0 1.78 1.78 0 4 0H16L20 4H36C37.0609 4 38.0783 4.42143 38.8284 5.17157C39.5786 5.92172 40 6.93913 40 8V14.2C42.48 16.72 44 20.18 44 24ZM30 14C27.3478 14 24.8043 15.0536 22.9289 16.9289C21.0536 18.8043 20 21.3478 20 24C20 26.6522 21.0536 29.1957 22.9289 31.0711C24.8043 32.9464 27.3478 34 30 34C32.6522 34 35.1957 32.9464 37.0711 31.0711C38.9464 29.1957 40 26.6522 40 24C40 21.3478 38.9464 18.8043 37.0711 16.9289C35.1957 15.0536 32.6522 14 30 14Z",
    fill: "#F79009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecord);
export default __webpack_public_path__ + "static/media/NoRecord.58de72d3aa2079c2c8a25cb5785a87c4.svg";
export { ForwardRef as ReactComponent };